/* offer-system.js — オファー体系の共通JS (CHG-088 / DEV-H)
 *
 * 3面 (TOP条件バー4項目目スロット / PDPオファーバッジ / カートクーポンバナー) で共有。
 * 役割:
 *   1. Shopify.analytics.publish の安全ラッパー (pixel未対応でも落ちない — M-27)
 *   2. [data-offer-copy] のタップコピー (clipboard → execCommand → 選択 の3段フォールバック — M-19〜M-22)
 *   3. [data-offer-view] の viewport 初回進入イベント (セッション内1回 — M-26)
 *   4. [data-offer-click] / [data-coupon-apply] のクリックイベント計測
 *
 * 同一srcの<script>が複数面から読まれても二重初期化しないガードつき。
 * イベント名は req-dev-h.md §3 の5種 (offer_bar_view / offer_bar_click / offer_badge_view /
 * offer_code_copy / offer_apply_click)。pixel側 subscribe はカーンの管理画面作業 (§7)。
 */
(function () {
  'use strict';
  if (window.__shogunOfferInit) return;
  window.__shogunOfferInit = true;

  /* ---- 1. analytics wrapper (req-dev-b L813 の typeof ガード版に準拠) ---- */
  function canPublish() {
    return (
      typeof window.Shopify === 'object' &&
      window.Shopify !== null &&
      typeof window.Shopify.analytics === 'object' &&
      window.Shopify.analytics !== null &&
      typeof window.Shopify.analytics.publish === 'function'
    );
  }
  function track(name, payload) {
    if (!canPublish()) return;
    try { window.Shopify.analytics.publish(name, payload); } catch (e) { /* 計測で落とさない */ }
  }

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, val) {
    try { window.sessionStorage.setItem(key, val); } catch (e) { /* private mode 等は黙って諦める */ }
  }

  /* ---- 2. tap copy ---- */
  var RESTORE_MS = 2000;

  function labelEl(btn) { return btn.querySelector('[data-offer-copy-label]'); }

  function setLabel(btn, text) {
    var el = labelEl(btn);
    if (el) el.textContent = text;
  }

  function markCopied(btn, method, code) {
    setLabel(btn, method === 'select' ? 'Selected' : 'Copied');
    btn.classList.add('is-copied');
    track('offer_code_copy', {
      code: code,
      surface: btn.getAttribute('data-offer-surface') || 'unknown',
      method: method
    });
    window.setTimeout(function () {
      setLabel(btn, 'Tap to copy');
      btn.classList.remove('is-copied');
    }, RESTORE_MS);
  }

  function fallbackCopy(btn, code) {
    /* 第2段: 一時textarea + execCommand('copy') (非セキュアコンテキスト・古いWebView) */
    try {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      if (ok) { markCopied(btn, 'execCommand', code); return; }
    } catch (e) { /* fall through */ }
    /* 第3段: コード文字列を選択状態にする */
    try {
      var codeEl = btn.querySelector('[data-offer-code-text]') || btn;
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      markCopied(btn, 'select', code);
    } catch (e2) {
      setLabel(btn, code); /* 最後の砦: コードだけは見せる */
    }
  }

  function handleCopyClick(btn) {
    var code = btn.getAttribute('data-offer-copy');
    if (!code) return;
    var usedAsync = false;
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        usedAsync = true;
        navigator.clipboard.writeText(code).then(
          function () { markCopied(btn, 'clipboard', code); },
          function () { fallbackCopy(btn, code); }
        );
      }
    } catch (e) { usedAsync = false; }
    if (!usedAsync) fallbackCopy(btn, code);
  }

  /* ---- 3. view once per session ---- */
  function fireView(el) {
    var kind = el.getAttribute('data-offer-view'); /* 'bar' | 'badge' */
    var key = 'shogun_offer_seen_' + kind;
    if (storageGet(key)) return;
    storageSet(key, '1');
    var payload = {
      offer_id: el.getAttribute('data-offer-id') || 'unknown',
      surface: kind
    };
    if (kind === 'bar') {
      payload.template = el.getAttribute('data-offer-template') || '';
      track('offer_bar_view', payload);
    } else {
      track('offer_badge_view', payload);
    }
  }

  function observeViews() {
    var targets = document.querySelectorAll('[data-offer-view]');
    if (!targets.length) return;
    if (typeof window.IntersectionObserver !== 'function') {
      /* IOが無い環境では描画時点で1回発火 (M-26のセッション内重複ガードは共通) */
      for (var i = 0; i < targets.length; i++) fireView(targets[i]);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        fireView(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    for (var j = 0; j < targets.length; j++) {
      var key = 'shogun_offer_seen_' + targets[j].getAttribute('data-offer-view');
      if (storageGet(key)) continue; /* 既視ならobserveすらしない */
      io.observe(targets[j]);
    }
  }

  /* ---- 4. click delegation ---- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || typeof t.closest !== 'function') return;

    var copyBtn = t.closest('[data-offer-copy]');
    if (copyBtn) { handleCopyClick(copyBtn); return; }

    var clickEl = t.closest('[data-offer-click]');
    if (clickEl) {
      var kind = clickEl.getAttribute('data-offer-click'); /* 'bar' | 'badge' */
      var payload = {
        offer_id: clickEl.getAttribute('data-offer-id') || 'unknown',
        surface: kind
      };
      if (kind === 'bar') {
        payload.destination = clickEl.getAttribute('href') || '';
        track('offer_bar_click', payload);
      } else {
        payload.action = 'link';
        track('offer_badge_click', payload);
      }
      /* リンク遷移は妨げない (計測はfire-and-forget) */
    }

    var applyEl = t.closest('[data-coupon-apply]');
    if (applyEl) {
      track('offer_apply_click', { code: 'WELCOME10', surface: 'cart' });
    }
  }, { passive: true });

  /* ---- 5. オファーバーの dismiss (カーンFB 2026-08-30: ×で閉じられるのが一般的) ----
   * sessionStorage でそのセッション中のみ非表示 (翌セッションで復活)。
   * 閉じたら shogun:chrome-change を投げ、sh-header.js が sticky 位置を再計測する。 */
  var DISMISS_KEY = 'shogun_offerbar_dismissed';
  function hideOfferBar() {
    var host = document.querySelector('[data-offer-bar-host]');
    if (!host) return;
    var section = host.closest('.shopify-section') || host;
    section.hidden = true;
    section.style.display = 'none';
    try { document.dispatchEvent(new CustomEvent('shogun:chrome-change')); } catch (e) { /* no-op */ }
  }
  function initDismiss() {
    if (storageGet(DISMISS_KEY) === '1') {
      hideOfferBar();
      return;
    }
    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest && event.target.closest('[data-offer-bar-close]');
      if (!btn) return;
      storageSet(DISMISS_KEY, '1');
      hideOfferBar();
      track('offer_bar_dismiss', { surface: 'bar' });
    });
  }

  /* ---- 6. バンドルカード選択 (CHG-091追補7 / カーンFB 2026-08-31: im8参考のカードUI) ----
   * [data-offer-qty] カードのタップで PDP の数量セレクタへ 1 / 3 をセット。
   * 手動の数量変更 (input change) にも追従して選択状態を同期する。 */
  function findQtyInput() {
    return document.querySelector('.product-form__quantity input[name="quantity"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
  }

  function syncBundleCards(qty) {
    var cards = document.querySelectorAll('[data-offer-qty]');
    for (var i = 0; i < cards.length; i++) {
      var on = parseInt(cards[i].getAttribute('data-offer-qty'), 10) === qty;
      cards[i].classList.toggle('is-selected', on);
      cards[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function initBundleCards() {
    if (!document.querySelector('[data-offer-qty]')) return;
    var input = findQtyInput();
    syncBundleCards(input ? parseInt(input.value, 10) || 1 : 1);

    document.addEventListener('click', function (ev) {
      var card = ev.target && ev.target.closest && ev.target.closest('[data-offer-qty]');
      if (!card) return;
      var qty = parseInt(card.getAttribute('data-offer-qty'), 10);
      if (!qty) return;
      var inp = findQtyInput();
      if (inp) {
        inp.value = qty;
        try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { /* no-op */ }
      }
      syncBundleCards(qty);
      track('offer_bundle_select', { qty: qty, offer_id: 'b2g1', surface: 'pdp' });
    });

    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t && t.name === 'quantity') syncBundleCards(parseInt(t.value, 10) || 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeViews(); initDismiss(); initBundleCards(); });
  } else {
    observeViews();
    initDismiss();
    initBundleCards();
  }
})();
